import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=6b6b48c2"
import script from "./viewer.vue?vue&type=script&lang=js"
export * from "./viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports